import { Domain, HostnameDomain } from "./constants";

function getReviewDomain(hostname: string): Domain | undefined {
  return hostname.match(
    /-(app|ch|io)\.[^.]+\.kube\.geops\.io(?:[/?#:]|$)/,
  )?.[1] as Domain | undefined;
}

export function isE2eHostname(hostname) {
  return /^nginx\.(ch|io|app)$/.test(hostname);
}

export function getHostnameDomain(hostname: string): HostnameDomain {
  const reviewDomain = getReviewDomain(hostname);
  if (reviewDomain) {
    return reviewDomain;
  }

  if (new RegExp(`[.-]${HostnameDomain.Bernmobil}`).test(hostname)) {
    return HostnameDomain.Bernmobil;
  }

  if (new RegExp(`[.-]${HostnameDomain.App}`).test(hostname)) {
    return HostnameDomain.App;
  }

  if (new RegExp(`[.-]${HostnameDomain.Io}`).test(hostname)) {
    return HostnameDomain.Io;
  }

  if (new RegExp(`[.-]${HostnameDomain.Ch}`).test(hostname)) {
    return HostnameDomain.Ch;
  }

  return HostnameDomain.Ch;
}

// return ch, io or app
export function getRegionDomain(hostname: string): Domain {
  const reviewDomain = getReviewDomain(hostname);
  if (reviewDomain) {
    return reviewDomain;
  }

  if (new RegExp(`[.-]${Domain.App}`).test(hostname)) {
    return Domain.App;
  }

  if (new RegExp(`[.-]${Domain.Io}`).test(hostname)) {
    return Domain.Io;
  }

  if (new RegExp(`[.-]${Domain.Ch}`).test(hostname)) {
    return Domain.Ch;
  }

  return Domain.Ch;
}

export default {
  getHostnameDomain,
  getRegionDomain,
};
